module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00011-efb2ddc53c66584b981d7d0001f0300e.jpg";